import CalendarEvent from 'mini-calendar-event-types/lib/MiniCalendarEvent';

export const isInDayItemCurrentItem = (inDayItem: CalendarEvent, currentItem: CalendarEvent) => {
    const {
        ItemId: { Id: inDayItemId } = {},
        SeriesMasterItemId: { Id: seriesMasterItemId } = {},
    } = inDayItem;

    const {
        ItemId: { Id: currentItemId } = {},
        SeriesMasterItemId: { Id: currentSeriesMasterItemId } = {},
    } = currentItem;

    const isCurrentItem =
        currentSeriesMasterItemId === seriesMasterItemId
            ? !!currentItemId && inDayItemId === currentItemId
            : !!currentItemId && [inDayItemId, seriesMasterItemId].includes(currentItemId);

    return isCurrentItem;
};
